// SandboxedApp — what a viewer mounts for an AI-generated app with the
// `appsSandbox` flag on (ISOLATED-RUNTIME-PLAN §8.2). The app runs in an
// OPAQUE-ORIGIN frame (sandbox="allow-scripts", nothing else): it cannot reach
// the member's session, storage, SDK or the shell DOM. Its only line to the
// shell is the port functions/sandboxHost.js serves.
//
// The label above the frame marks the area as app content (§3.5): the frame
// cannot draw over it, so a fake "sign in again" form inside the app is never
// mistaken for the shell's own.
//
// Data (set by functions/generatedAppSandbox.js sandboxAppDef): sandboxApp
// { name, expr, jsonAuthored, entities, stateSeed } — plain data.
// State written by functions/mountSandboxedApp.js: sandboxHeight (the frame's
// measured height), sandboxStopped (the teardown reason).
export const SandboxedApp = {
  flow: 'y',
  gap: 'Z',
  state: { sandboxHeight: 0, sandboxStopped: '' },

  SandboxLabel: {
    fontSize: 'Z1',
    color: 'caption',
    text: (el) => el.call('polyglot', 'workspace.sandbox.marker')
  },

  SandboxStopped: {
    if: (el, s) => !!s.sandboxStopped,
    color: 'caption',
    text: (el) => el.call('polyglot', 'workspace.sandbox.stopped')
  },

  Iframe: {
    if: (el, s) => !s.sandboxStopped,
    attr: { sandbox: 'allow-scripts' },
    title: (el) => el.call('polyglot', 'workspace.sandbox.frameTitle'),
    width: '100%',
    border: 'none',
    // Two real branches, never null: a null CSS prop is a tombstone (it
    // emits nothing AND deletes the inherited declaration). Unmeasured, the
    // frame keeps its intrinsic height.
    height: (el, s) => (s.sandboxHeight ? s.sandboxHeight + 'px' : 'auto'),
    onRender: (el) => el.call('mountSandboxedApp', el.node, el.parent.sandboxApp),
    onRemove: (el) => {
      const app = el.scope && el.scope.sandboxApp
      if (app && typeof app.teardown === 'function') app.teardown('removed')
    }
  }
}
